import React from "react";

const ProfilesApprovals = () => {
    return (
        <div>
            Profiles Approvals
        </div>
    );
}

export default ProfilesApprovals;